import { FaRunning } from "react-icons/fa"
import { IoSnowOutline } from "react-icons/io5"
import { MdSettingsPower } from "react-icons/md"
import { FaExclamation } from "react-icons/fa"
import { IconFilter } from "../../SubPlants/SP_Filter/IconFilter"
import { schema as defaultSchema} from "./types"
import { colors } from "baseui/tokens"

export const Icon = (props: any) => {

    return (<FaExclamation {...props}></FaExclamation>)
}